import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import { ConfigProvider } from '../config/config';
import { Events, Platform } from 'ionic-angular';
import { LoadingProvider } from '../loading/loading';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { Device } from '@ionic-native/device';
import { Facebook } from '@ionic-native/facebook';
import { FCM } from '@ionic-native/fcm';
import { OneSignal } from '@ionic-native/onesignal';
import {Observable} from 'rxjs/Rx';
import { Subscription } from 'rxjs';
import { Pro } from '@ionic/pro';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import moment from 'moment';

@Injectable()
export class SharedDataProvider {
	private onResumeSubscription: Subscription;
  public banners;
  public tab1: any;
  public tab2: any;
  public tab3: any;
  public categories = new Array();
  public subCategories = new Array();
  public customerData: { [k: string]: any } = {};
  public recentViewedProducts = new Array();
  public cartProducts = new Array();
  public privacyPolicy;
  public termServices;
  public refundPolicy;
  public aboutUs;
  public cartquantity;
  public wishList = new Array();
  public tempdata: { [k: string]: any } = {};
  public dir = "ltr";
  public selectedFooterPage = "HomePage";

  public orderDetails = {
    tax_zone_id: "",
    delivery_firstname: "",
		contactPref:"both",
    delivery_lastname: "",
    delivery_state: "",
    delivery_city: "",
    delivery_postcode: "",
    delivery_zone: "",
    delivery_country: "",
    delivery_country_id: "",
    delivery_street_address: "",
    delivery_country_code: "",
		customers_telephone :"",
    billing_firstname: "",
    billing_lastname: "",
    billing_state: "",
    billing_city: "",
    billing_postcode: "",
    billing_zone: "",
    billing_country: "",
    billing_country_id: "",
    billing_street_address: "",
    billing_country_code: "",
    total_tax: '',
    additional_parts: '',
    additional_labor:'',
    shipping_cost: '',
    shipping_method: '',
    payment_method: '',
    comments: '',
		previeworder:'',
		quote_type:'',
		serialNumber:'',
		customers_email_address:''
  };

	 public survey_images = {
		 gas_rate_image:[],
		 trv_installed: [],
		 gas_gauge_working_pressure_image:[],
		 analyser_in_flue_image:[],
		 pipework_underneath_boiler_image:[],
		 analyser_reading_image:[],
		 underneath_boiler_image:[],
		 new_flue_image:[],
		 front_elevation_image:[],
		 rear_elevation_image:[],
		 right_elevation_image:[],
		 left_elevation_image:[],
		 new_flue_internal_image:[],
		 installed_radiator_image:[],
		 main_entrance_elevation_image:[],
		 new_data_badge_image:[],
		 new_boiler_on_wall_image:[],
		 new_flue_side_image:[],
		 condense_termination_image:[],
		 condense_pipe_thru_wall:[],
		 property_detachment_image:[],
		 wall_thickness_image:[],
		 heating_controls_image:[],
		 new_heating_controls_image:[],
		 doors_image:[],
		 ufi_access_image:[],
		 ufi_measurements_image:[],
		 ufi_clear_space_image:[],
		 ufi_general_image:[],
		 damp_meter_readings_image:[],
		 vents_clear_image:[],
		 fused_spur_image:[],
		 ufi_pre_install:[],
		 ufi_mid_install:[],
		 ufi_install_complete:[],
		 ufi_vents_clear:[],
		 ufi_damp_meter_reading:[],
		 ufi_measurements_pica:[],
		 full_boiler_images:[],
		 gas_meter_images:[],
		 flue_internal_image:[],
		 flue_external_image:[],
		 radiators_image:[],
		 trv_images:[],
		 bedrooms_image:[],
		 windows_image:[],
		 extractors_image:[],
		 vent_bricks_image:[],
		 co_alarm_image:[],
		 existing_boiler_data_badge:[],
		 existing_boiler_flue_internal:[],
		 existing_boiler_flue_external:[],
		 existing_boiler_image:[],
		 boiler_off_wall_image:[],
		 proof_of_address_image:[],
		 dpc_internal_external_image:[],
		 remedial_image:[],
		 vents_internal_image:[],
		 vents_external_image:[],
		 bypass_rad_image:[],
		 loft_suitable_piv:[]
	 };

  constructor(
    public config: ConfigProvider,
    public http: Http,
    private storage: Storage,
    public loading: LoadingProvider,
    public events: Events,
    private push: Push,
    public platform: Platform,
    private device: Device,
    private fcm: FCM,
    private oneSignal: OneSignal,
		private ga: GoogleAnalytics,
    //private fb: Facebook,
  ) {
    //getting all banners
    this.http.get(config.url + 'getBanners').map(res => res.json()).subscribe(data => {

      this.banners = data.data;
    });
		this.config.langId = '1';

    this.onResumeSubscription = platform.resume.subscribe(() => {
			 this.banners  = [];
			this.http.get(config.url + 'getBanners').map(res => res.json()).subscribe(data => {
			 this.banners = data.data;
		 });
    });

		this.storage.set('direction1','ltr');
		//getting recent viewed items from local storage
		storage.get('customerData').then((val) => {

			console.log("Got Storage:",val);
			if (val != null || val != undefined)
			{

			this.customerData = val;

			}
			else{
				this.customerData.langId = '1';
			}


    //getting tab 1
    let data: { [k: string]: any } = {};
		//console.log("#### Got Customer:",this.customerData.customers_id);
	//Pro.monitoring.log('Customer ID: ' + this.customerData.customers_id, { level: 'info' });


    //if (this.customerData.customers_id != null)
    data.customers_id = this.customerData.customers_id;
    data.page_number = 0;
    data.language_id = config.langId;


    //getting all allCategories
    this.http.post(config.url + 'allCategories', { language_id: config.langId }).map(res => res.json()).subscribe(data => {
      for (let value of data.data) {
        if (value.parent_id == 0) this.categories.push(value);
        else this.subCategories.push(value);
      }
    });

				});

    //getting recent viewed items from local storage
    storage.get('recentViewedProducts').then((val) => {
      if (val != null) this.recentViewedProducts = val;
    });

    //getting recent viewed items from local storage
    storage.get('cartProducts').then((val) => {
      if (val != null) this.cartProducts = val;
      this.cartTotalItems();
      // console.log(val);
    });


    //getting allpages from the server
    this.http.post(config.url + 'getAllPagesGC', { language_id: this.config.langId , brand_id:this.config.brandId}).map(res => res.json()).subscribe(data => {
      if (data.success == 1) {
        let pages = data.pages_data;
        for (let value of pages) {
          if (value.slug == 'privacy-policy') this.privacyPolicy = value.description;
          if (value.slug == 'term-services') this.termServices = value.description;
          if (value.slug == 'refund-policy') this.refundPolicy = value.description;
          if (value.slug == 'about-us') this.aboutUs = value.description;
        }
      }
    });

    //subscribe for push notifiation
    this.platform.ready().then(() => {
      this.storage.get('pushNotification').then((val) => {
        if (val == undefined) {
          this.subscribePush();
          this.storage.set('pushNotification', "loaded");
        }
      });
    });
    //---------------- end -----------------
  }

	resetSurveyImages(){
		this.survey_images = {
 		 gas_rate_image:[],
 		 trv_installed: [],
 		 gas_gauge_working_pressure_image:[],
 		 analyser_in_flue_image:[],
 		 pipework_underneath_boiler_image:[],
 		 analyser_reading_image:[],
		 underneath_boiler_image:[],
		 new_flue_image:[],
		 front_elevation_image:[],
		 rear_elevation_image:[],
		 right_elevation_image:[],
		 left_elevation_image:[],
		 new_flue_internal_image:[],
		 installed_radiator_image:[],
		 main_entrance_elevation_image:[],
		 new_data_badge_image:[],
		 new_boiler_on_wall_image:[],
		 new_flue_side_image:[],
		 condense_termination_image:[],
		 condense_pipe_thru_wall:[],
		 property_detachment_image:[],
		wall_thickness_image:[],
		heating_controls_image:[],
		new_heating_controls_image:[],
		bedrooms_image:[],
		vent_bricks_image:[],
		extractors_image:[],
		ufi_access_image:[],
		ufi_measurements_image:[],
		ufi_clear_space_image:[],
		ufi_general_image:[],
		damp_meter_readings_image:[],
		vents_clear_image:[],
		fused_spur_image:[],
		ufi_pre_install:[],
		ufi_mid_install:[],
		ufi_install_complete:[],
		ufi_vents_clear:[],
		ufi_damp_meter_reading:[],
		ufi_measurements_pica:[],
		full_boiler_images:[],
		gas_meter_images:[],
		flue_internal_image:[],
		flue_external_image:[],
		radiators_image:[],
		trv_images:[],
		windows_image:[],
		doors_image:[],
		co_alarm_image:[],
		existing_boiler_data_badge:[],
		existing_boiler_flue_internal:[],
		existing_boiler_flue_external:[],
		existing_boiler_image:[],
		boiler_off_wall_image:[],
		proof_of_address_image:[],
		dpc_internal_external_image:[],
		remedial_image:[],
		vents_internal_image:[],
		vents_external_image:[],
		bypass_rad_image:[],
		loft_suitable_piv:[]

 	 };
	}

	ngOnDestroy() {
	// always unsubscribe your subscriptions to prevent leaks
	this.onResumeSubscription.unsubscribe();
}
  //adding into recent array products
  addToRecent(p) {
    let found = false;
    for (let value of this.recentViewedProducts) {
      if (value.products_id == p.products_id) { found = true; }
    }
    if (found == false) {
      this.recentViewedProducts.push(p);
      this.storage.set('recentViewedProducts', this.recentViewedProducts);
    }
  }
  //removing from recent array products
  removeRecent(p) {
    this.recentViewedProducts.forEach((value, index) => {
      if (value.products_id == p.products_id) {
        this.recentViewedProducts.splice(index, 1);
        this.storage.set('recentViewedProducts', this.recentViewedProducts);
      }
    });
  }
  //adding into cart array products
  addToCart(product, attArray) {

    // console.log(this.cartProducts);
    let attributesArray = attArray;
    if (attArray.length == 0 || attArray == null) {
      //console.log("filling attirbutes");
      attributesArray = [];
      if (product.attributes != undefined) {
        // console.log("filling product default attibutes");
        product.attributes.forEach((value, index) => {
          let att = {
            products_options_id: value.option.id,
            products_options: value.option.name,
            products_options_values_id: value.values[0].id,
            options_values_price: value.values[0].price,
            price_prefix: value.values[0].price_prefix,
            products_options_values: value.values[0].value,
            name: value.values[0].value + ' ' + value.values[0].price_prefix + value.values[0].price + " " + this.config.currency
          };
          attributesArray.push(att);
        });
      }
    }
    //  if(checkDublicateService(product.products_id,$rootScope.cartProducts)==false){
		console.log("Product Price:",product);
		var pprice = product.products_price;
		if(product.arSpecial ==1)
		{
    pprice = product.arSpecialPrice;
		}

		let on_sale = false;
    if (product.discount_price != null) {
      pprice = product.discount_price;
      on_sale = true;
    }
    // console.log("in side producs detail");
    // console.log(attributesArray);
    // console.log(this.cartProducts);
    let finalPrice = this.calculateFinalPriceService(attributesArray) + parseFloat(pprice);
    let obj = {
      cart_id: product.products_id + this.cartProducts.length,
      products_id: product.products_id,
      manufacture: product.manufacturers_name,
      customers_basket_quantity: 1,
      final_price: finalPrice,
      model: product.products_model,
      categories_id: product.categories_id,
      categories_name: product.categories_name,
      // quantity: product.products_quantity,
      weight: product.products_weight,
      on_sale: on_sale,
      unit: product.products_weight_unit,
      image: product.products_image,

      attributes: attributesArray,
      products_name: product.products_name,
      price: pprice,
      isPack:product.isPack,
			arSpecial:product.arSpecial,
			arSpecialPrice:product.arSpecialPrice,
      subtotal: finalPrice,
      total: finalPrice
    }
    console.log("Cart1:",obj);
    this.cartProducts.push(obj);
    this.storage.set('cartProducts', this.cartProducts);

    this.cartTotalItems();

    // console.log(this.cartProducts);
    //console.log(this.cartProducts);
  }
  //removing from recent array products
  removeCart(p) {
    this.cartProducts.forEach((value, index) => {
      if (value.cart_id == p) {
        this.cartProducts.splice(index, 1);
        this.storage.set('cartProducts', this.cartProducts);
      }
    });
    this.cartTotalItems();
  }
  emptyCart() {
    this.cartProducts = [];
    this.storage.set('cartProducts', this.cartProducts);
    this.cartTotalItems();
  }
  emptyRecentViewed() {
    this.recentViewedProducts = [];
    this.storage.set('recentViewedProducts', this.recentViewedProducts);
  }
  calculateFinalPriceService(attArray) {
    let total = 0;
    attArray.forEach((value, index) => {
      let attPrice = parseFloat(value.options_values_price);
      if (value.price_prefix == '+') {
        //  console.log('+');
        total += attPrice;
      }
      else {
        //  console.log('-');
        total -= attPrice;
      }
    });
    // console.log("max "+total);
    return total;
  }

  //Function calcualte the total items of cart
  cartTotalItems = function () {
    this.events.publish('cartChange');
    let total = 0;
    for (let value of this.cartProducts) {

      total += value.customers_basket_quantity;
    }
    this.cartquantity = total;
    // console.log("updated");
    return total;
  };

  removeWishList(p) {
    this.loading.show();
    let data: { [k: string]: any } = {};
    data.liked_customers_id = this.customerData.customers_id;
    data.liked_products_id = p.products_id;
    this.http.post(this.config.url + 'unlikeProduct', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      if (data.success == 1) {
        this.events.publish('wishListUpdate', p.products_id, 0);
        p.isLiked = 0;
        this.wishList.forEach((value, index) => {
          if (value.products_id == p.products_id) this.wishList.splice(index, 1);
        });
      }
      if (data.success == 0) {

      }
    });
  }
  addWishList(p) {
    this.loading.show();
    let data: { [k: string]: any } = {};
    data.liked_customers_id = this.customerData.customers_id;
    data.liked_products_id = p.products_id;
    this.http.post(this.config.url + 'likeProduct', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      if (data.success == 1) {
        this.events.publish('wishListUpdate', p.products_id, 1);
        p.isLiked = 1;
      }

      if (data.success == 0) { }
    });
  }


  login(data) {
		//console.log("Logging ON:",this.customerData);
    this.customerData = data;
		this.subscribePush();
		console.log("Customer:", this.customerData);
    this.storage.set('customerData', this.customerData);

  }
  logOut() {
    this.loading.autoHide(500);
    this.customerData = {};
		this.emptyRecentViewed();
    this.storage.set('customerData', this.customerData);
    // this.fb.logout();
  }


  //============================================================================================
  //getting token and passing to server
  subscribePush() {

		  if(this.platform.is('core') || this.platform.is('mobileweb')) {
				return;
			}

		console.log("Subscribe to OneSIgnal Push",this.config.notificationType);
    // pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));
			// Set your iOS Settings
			// Set your iOS Settings
		 var iosSettings = {};

		 iosSettings["kOSSettingsKeyAutoPrompt"] = false;
		 iosSettings["kOSSettingsKeyInAppLaunchURL"] = false;
//Remove this method to stop OneSignal Debugging
  //  window["plugins"].OneSignal.setLogLevel({logLevel: 6, visualLevel: 0});
		this.config.onesignalAppId = "b32ed191-0035-4519-8921-8ee848b42777";

		// OneSignal Initialization
		window["plugins"].OneSignal.setAppId("b32ed191-0035-4519-8921-8ee848b42777");
		//this.oneSignal.setAppId("b32ed191-0035-4519-8921-8ee848b42777");

		//this.oneSignal.startInit(this.config.onesignalAppId);
	//	this.oneSignal.iOSSettings(iosSettings);
		//this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);

		//this.oneSignal.handleNotificationReceived().subscribe(() => {
    // do something when notification is received
	//});




	window["plugins"].OneSignal.setNotificationWillShowInForegroundHandler(function(notificationReceivedEvent) {
	  notificationReceivedEvent.complete(notificationReceivedEvent.notification);
		console.log("setNotificationWillShowInForegroundHandler",JSON.stringify(notificationReceivedEvent));
	});


//		window["plugins"].OneSignal.getIds().then((data) => {
//			console.log("Register Device:",data.userId);
//			this.registerDevice(data.userId);
//		})

		window["plugins"].OneSignal.getDeviceState(function(stateChanges) {
  console.log('OneSignal getDeviceState: ' + JSON.stringify(stateChanges));
});


window["plugins"].OneSignal.setInAppMessageClickHandler(function(jsonData){
	var notificationData = JSON.stringify(jsonData)
	console.log('notificationOpenedCallback: ' , notificationData);

});

window["plugins"].OneSignal.setNotificationOpenedHandler(function(jsonData){
	var notificationData = JSON.stringify(jsonData)
	console.log('notificationOpenedCallback: ' , notificationData);
	//this.navCtrl.push(LeadDetailPage, { lead: '2222' });

});
var self = this;
window["plugins"].OneSignal.getDeviceState(function(stateChanges) {
  console.log('OneSignal getDeviceState: ' + JSON.stringify(stateChanges));
	self.registerDevice(stateChanges.userId);
});


  }

  //============================================================================================
  //registering device for push notification function
  registerDevice(registrationId) {
    //this.storage.get('registrationId').then((registrationId) => {
    console.log(registrationId);
    let data: { [k: string]: any } = {};
    if (this.customerData.customers_id == null)
      data.customers_id = null;
    else
      data.customers_id = this.customerData.customers_id;
    //	alert("device ready fired");
    let deviceInfo = this.device;
    data.device_model = deviceInfo.model;
    data.device_type = deviceInfo.platform;
    data.device_id = registrationId;
    data.device_os = deviceInfo.version;
    data.manufacturer = deviceInfo.manufacturer;
    data.ram = '';
    data.processor = '';
    data.location = '';

    // alert(JSON.stringify(data));
    this.http.post(this.config.url + "registerDevices", data).map(res => res.json()).subscribe(data => {
      //  alert(registrationId + " " + JSON.stringify(data));
    });
    //  });

  }

  showAd() {
    //this.loading.autoHide(2000);
    this.events.publish('showAd');
  }

}
//  return new Promise(resolve => {
    //     resolve(data.product_data);
    //   });



// WEBPACK FOOTER //
// ./src/providers/shared-data/shared-data.ts